<div class="executive-jobs-container">
  <!-- Custom Transparent Header with centered logo image -->
  <header class="exec-header">
    <a href="/">
      <img src="assets/imgs/Zumeralogo-WHITE.png" alt="Zumera" class="exec-logo-img" />
    </a>
  </header>

  <!-- Hero Section -->
  <div class="exec-hero-section" #heroSection>
    <div class="exec-bg-image-wrapper">
      <img src="assets/Rectangle 82.png" alt="Hero background" class="exec-bg-image" />
      <div class="exec-hero-overlay"></div>
    </div>
    
    <div class="exec-content-wrapper">
      <div class="exec-intro-content">
        <div class="exec-intro-text">
          <h1 class="exec-hero-title">WE ARE INSPIRED BY THE IMPOSSIBLE</h1>
          <p>We started Zumera because we wanted to make a contribution, and that contribution is our very existence: <strong>To Revealing Africa's Power, Freedom and Beauty To The World Through A New Standard of Peerless Hospitality.</strong></p>
          <p>On this journey, our greatest asset is our People, Men and Women from different tribes and backgrounds, experts and lifelong learners united by <strong>one mission</strong> and working side by side to bring it to reality. And now, you may become one of our greatest assets.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Jobs List -->
  <div class="exec-jobs-list">
    <div class="exec-job-card">
      <h3 class="exec-job-title">Chief Design Officer</h3>
      <button class="exec-apply-btn" [routerLink]="['/join-our-tribe', 'architect-designer']">Apply</button>
    </div>

    <div class="exec-job-card">
      <h3 class="exec-job-title">Chief Financial Officer</h3>
      <button class="exec-apply-btn" [routerLink]="['/join-our-tribe', 'chief-financial-officer']">Apply</button>
    </div>

    <div class="exec-job-card">
      <h3 class="exec-job-title">Vice President ZUMERA EWEKA</h3>
      <button class="exec-apply-btn" [routerLink]="['/join-our-tribe', 'vice-president-zumera-eweka']">Apply</button>
    </div>

    <div class="exec-job-card">
      <h3 class="exec-job-title">Chief Development Officer</h3>
      <button class="exec-apply-btn" [routerLink]="['/join-our-tribe', 'chief-development-officer']">Apply</button>
    </div>

    <div class="exec-job-card">
      <h3 class="exec-job-title">Chief Civil Structural Consultant</h3>
      <button class="exec-apply-btn" [routerLink]="['/join-our-tribe', 'chief-civil-structural-consultant']">Apply</button>
    </div>

    <div class="exec-job-card">
      <h3 class="exec-job-title">Chief Legal Officer</h3>
      <button class="exec-apply-btn" [routerLink]="['/join-our-tribe', 'chief-legal-officer']">Apply</button>
    </div>

    <div class="exec-job-card">
      <h3 class="exec-job-title">Chief Business Development Officer</h3>
      <button class="exec-apply-btn" [routerLink]="['/join-our-tribe', 'chief-business-development-officer']">Apply</button>
    </div>

    <div class="exec-job-card">
      <h3 class="exec-job-title">Chief Human Resources Officer</h3>
      <button class="exec-apply-btn" [routerLink]="['/join-our-tribe', 'chief-human-resources-officer']">Apply</button>
    </div>

    <div class="exec-job-card">
      <h3 class="exec-job-title">Chief Marketing And Communication<br />Officer</h3>
      <button class="exec-apply-btn" [routerLink]="['/join-our-tribe', 'chief-marketing-and-communication-officer']">Apply</button>
    </div>
  </div>
</div>

<app-figma-benin-footer></app-figma-benin-footer>
